import '@aurora/ui-kit/styles.css';
import './styles.css';

import { ConfirmProvider, ToastProvider } from '@aurora/ui-kit';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';

import { App } from './App.js';
import { refreshBranding } from './state/branding.js';
import { applyTheme } from './state/theme.js';

// Erster Paint: Theme + gecachtes Branding sofort, frisches Branding async.
applyTheme();
void refreshBranding();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ToastProvider>
          <ConfirmProvider>
            <App />
          </ConfirmProvider>
        </ToastProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
